import React from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import styles from './Footer.module.scss';

function Text() {

  return (
      <div className={styles.footer}>
        <Container className={styles.footerContainer}>
          <Row>
            <Col xs={12}>
              <h5 className={styles.companyName}>© 2026 Вэдмаркет</h5>
            </Col>
          </Row>
        </Container>
      </div>
  );
}

export default Text;
